import { useCallback } from 'react';

import type { ValidationErrorsSourceExportUnavailableReason } from '@/lib/graphql/generated/graphql';

import {
  useExportValidationErrors,
  type ValidationErrorsExportType,
} from './useExportValidationErrors';

/** L'export demandé depuis le panneau d'anomalies. */
export type ValidationErrorsExportRequest = {
  exportType: ValidationErrorsExportType;
  /** Pourquoi `source` n'était pas proposé, pour le suivi de l'export `so`. */
  unavailableReason?: ValidationErrorsSourceExportUnavailableReason | null;
};

/**
 * Les deux exports des erreurs du panneau d'anomalies : le fichier d'origine
 * (`source`) et celui de la phase 1 (`so`, par défaut). Monté hors du panneau
 * pour que le téléchargement aboutisse même s'il est refermé entre-temps.
 */
export function useValidationErrorsExports(
  dealId: string,
  dealName: string,
  anomalyTypesCount: number
) {
  const so = useExportValidationErrors(
    dealId,
    dealName,
    anomalyTypesCount,
    'so'
  );
  const source = useExportValidationErrors(
    dealId,
    dealName,
    anomalyTypesCount,
    'source'
  );
  const { exportValidationErrors: exportSo } = so;
  const { exportValidationErrors: exportSource } = source;

  const exportErrors = useCallback(
    (request?: ValidationErrorsExportRequest) => {
      if (request?.exportType === 'source') {
        exportSource();
        return;
      }
      exportSo({ unavailableReason: request?.unavailableReason });
    },
    [exportSo, exportSource]
  );

  return {
    exportErrors,
    isExporting: so.isExporting || source.isExporting,
  };
}
